const o = (t) => ({
  btn: {
    ...t.typography.button,
    "&.MuiButton-outlined:hover": {
      border: 0
    }
  }
}), e = o;
export {
  e as default
};
